import React, { Component } from 'react'
import GreenButton from './misc/GreenButton'

export class Success extends Component {
    goToHome = () => {
        window.location.href = "/"
    }

    goToHomePage = () => {
        window.location.href = "https://wholechild.us"
    }

    render() {
        return (
            <div className="popup" onClick={this.props.OnSuccess}>
                <div className="info-popup">
                    <div className="check_mark">
                        <div className="sa-icon sa-success animate">
                            <span className="sa-line sa-tip animateSuccessTip"></span>
                            <span className="sa-line sa-long animateSuccessLong"></span>
                            <div className="sa-placeholder"></div>
                            <div className="sa-fix"></div>
                        </div>
                        <span className="success-text">We've sent an email with a link.<br /> Check it out!</span>

                    </div>
                    <img style={{ marginBottom: '-15%' }} alt="grey-snake" className="popup-pic" src={require("../assets/imgs/grey-snake.png")} />
                    <div className="send-again success-settings">
                        <GreenButton style={bottomPos} continue={this.goToHome} name="RETAKE TEST" />
                        <GreenButton style={bottomPos} continue={this.goToHomePage} name="GO TO WHOLECHILD.US" />
                    </div>
                </div>
            </div>
        )
    }
}

const bottomPos = {
    width: '180px',
    margin: '10px'
}

export default Success
